import { render, staticRenderFns } from "./awardList.vue?vue&type=template&id=6994986a&scoped=true&"
import script from "./awardList.vue?vue&type=script&lang=js&"
export * from "./awardList.vue?vue&type=script&lang=js&"
import style0 from "./awardList.vue?vue&type=style&index=0&id=6994986a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6994986a",
  null
  
)

export default component.exports